const dayjs = require('dayjs')

module.exports = function getAge (birthday) {
  return dayjs().diff(dayjs(birthday), 'year')
}
